import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
    http: HttpClient;
    settings: AuthConfig;

    constructor(private readonly httpHandler: HttpBackend) {
        this.http = new HttpClient(httpHandler);
    }

    init(endpoint: string): Promise<boolean> {
        return new Promise<boolean>((res, rej) => {
            this.http.get<AuthConfig>(endpoint)
                .subscribe(value => {
                    this.settings = value;
                    res(true);
                }, error => rej(error))
        })
    }

    get() {
        return this.settings;
    }
}

export interface AuthConfig {
    ClientId: string;
    TenantId: string;
    Instance: string;
    RedirectUri: string | null | undefined;
}
